const emitter = require('tiny-emitter/instance');

export default {
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args)
}

export enum EVENT_NAMES {
  CURRENCY_CHANGED = 'currency-change',
  LOCALE_CHANGED = 'locale-change',
  SHOW_GENIUS_INFO = 'show-genius-info',
  SHOW_ROOM_DESCRIPTION = 'show-room-description',
  UPDATE_PROGRESS = 'update-progress',
  SCROLL_SIDEBAR_LIST = 'scroll-sidebar-list',
  UPDATE_HOTELS = 'update-hotels',
  SUGGEST_ERROR = 'hasSuggestError',
  SHOW_BACK_BTN = 'showBackBtn',

  HOTEL_ITEM_INTERSECTING = 'hotel-item-intersecting',

  // Calendar events
  CALENDAR_UPDATE_SELECTED = 'calendar-update-selected',
  CALENDAR_ON_THIS_DAY = 'calendar-on-this-day',
  CALENDAR_CLEAR_DATES = 'calendar-clear-dates',
  CALENDAR_TRANSITION_END = 'calendar-transition-end',

  // KeyUp
  KEY_UP_ESCAPE = 'key-up-escape',
  KEY_UP_ARROW_RIGHT = 'key-up-arrow-right', // next
  KEY_UP_ARROW_LEFT = 'key-up-arrow-left', // prev

  // Carousel
  CAROUSEL_OPEN = 'carousel-open', // open

  
  MAP_FORCE_ZOOM_OUT = 'map-force-zoom-out'
}